import i18n from '../i18n';

const { FREE_FLASHCARD_LIMIT, PREMIUM_PRICE_USD, PREMIUM_PRICE_LABEL } = require('../shared/subscription');

export { FREE_FLASHCARD_LIMIT, PREMIUM_PRICE_USD, PREMIUM_PRICE_LABEL };

export function getUpgradeCopy() {
  return i18n.t('account.subscription.freeUpgradeCopy', { limit: FREE_FLASHCARD_LIMIT });
}
